/// <amd-module name="Wit/Common/Utilities/Iterator" />
/**
 * Generate a range from start (inclusive) to stop (exclusive).
 * @param start
 * @param stop
 * @param step
 */
 export function* range(start: number, stop?: number, step = 1) {
    if (stop === undefined) {
        stop = start;
        start = 0;
    }
    let i: number;
    for (i = start; i < stop; i += step) {
        yield i;
    }
}

/**
 * For each item the given generator generates, apply func. Returns an array.
 * @param gen
 * @param func
 */
export function mapToArray<Tin, Tout>(iterator: IterableIterator<Tin>, func: (val: Tin) => Tout): Tout[] {
    const result: Tout[] = [];
    for (const val of iterator) {
        result.push(func(val));
    }
    return result;
}

/**
 * For each item in the sequence, if the given function returns true, include it in the results array.
 * @param iterator
 * @param func
 * @returns
 */
 export function filterToArray<T>(iterator: IterableIterator<T>, func: (val: T) => boolean): T[] {
    const result: T[] = [];
    for (const val of iterator) {
        if (func(val)) {
            result.push(val);
        }
    }
    return result;
}
